@if (editions) {
  <glxy-form-field size="small">
    <mat-select
      data-cy="select-product-edition-dropdown"
      [value]="selectedEditionId"
      (selectionChange)="handleEditionChange($event)"
      >
      <mat-select-trigger>
        @if (selectedEditionId | findItemEdition: editions; as edition) {
          <span class="active-edition-label">
            {{ edition?.name }}
            @if (edition?.isActive) {
              <glxy-badge [size]="'small'" [color]="'blue'">
                {{ 'INVENTORY_UI.ACTIVE_ITEMS.STATUS.ACTIVE' | translate }}
              </glxy-badge>
            }
          </span>
        }
      </mat-select-trigger>
      @for (edition of editions; track edition) {
        <mat-option
          data-cy="edition-option"
          [disabled]="edition?.isActive"
          [value]="edition?.editionId || ''"
          >
          {{ edition?.name }}
          @if (edition?.isActive) {
            <glxy-badge [size]="'small'" [color]="'blue'">
              {{ 'INVENTORY_UI.ACTIVE_ITEMS.STATUS.ACTIVE' | translate }}
            </glxy-badge>
          }
        </mat-option>
      }
    </mat-select>
  </glxy-form-field>
}
